import { graphql } from "@/lib/gql/__generated__/gql";

export const VoucherForCampaignDefault_EditPage_Query = graphql(`
	query VoucherForCampaign_EditPage($hotelID: ID!, $voucherID: ID!) {
		voucherForCampaign(hotelID: $hotelID, voucherID: $voucherID) {
			hotelID
			voucherID
			inSale
			name
			description
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			voucherPrice {
				currencyType
				amount
			}
			resourceAvailablePrice {
				currencyType
				amount
			}
			voucherGiftList {
				guestName
				guestTel
				guestEmail
			}
			voucherExplanationForHost
			mailTemplate
			cinStart
			cinEnd
			createdAt
			deletedAt
		}
		hotel(hotelID: $hotelID) {
			email
		}
	}
`);
